module.exports = require('./html_img')



// WEBPACK FOOTER //
// ./src/playbacks/html_img/index.js